import { useEffect, useCallback, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import useStorage from 'commons/hooks/useStorage';
import { isTimestampExpired, validateDevice } from './utils';

export const VERIFY_TOKEN_KEY = 'verify-notification-token';
const REVALIDATE_TOKEN_AFTER_MS = 24 * 60 * 60 * 1000;
const IS_NATIVE_PLATFORM = Capacitor.isNativePlatform();

function useVerifyNotificationToken() {
  const [lastAttemptDate, setLastAttemptDate, storageLoaded] = useStorage<
    string | undefined
  >(VERIFY_TOKEN_KEY, undefined);

  const [hasValidatedInThisMount, setHasValidatedInThisMount] = useState(false);

  const needsDeviceValidation = isTimestampExpired(
    lastAttemptDate,
    REVALIDATE_TOKEN_AFTER_MS,
  );

  const shouldValidateDevice =
    IS_NATIVE_PLATFORM &&
    storageLoaded &&
    !hasValidatedInThisMount &&
    needsDeviceValidation;

  const handleValidateDevice = useCallback(async () => {
    setHasValidatedInThisMount(true);

    await validateDevice();

    setLastAttemptDate(new Date().toISOString());
  }, [setLastAttemptDate]);

  useEffect(() => {
    if (shouldValidateDevice) {
      handleValidateDevice();
    }
  }, [shouldValidateDevice, handleValidateDevice]);
}

export default useVerifyNotificationToken;
